import { LocalizationService } from '@abp/ng.core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { SelectorComponent } from 'src/ca-shared/selector/selector.module';
import { Operators } from 'src/core/models/request/operator.enum';
import { UserGroupSelectionConfigurationModel } from '../models/user-group-selection-configuration.model';
import { UserGroupDto } from 'src/core/models/user-group/user-group.dto';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';

@Component({
  selector: 'ca-user-group-selection-panel',
  templateUrl: './user-group-selection-panel.component.html',
  styleUrls: ['./user-group-selection-panel.component.scss'],
  standalone: false,
})
export class UserGroupSelectionPanelComponent extends FilterPanelEditorComponent implements OnInit {
  actualConfig: UserGroupSelectionConfigurationModel;

  _value: UserGroupDto[];
  userGroupSelectorOptions: any;
  userGroupFilters: FilterItemDto[];

  @ViewChild(SelectorComponent, { read: SelectorComponent })
  userGroupSelector: SelectorComponent;

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as UserGroupSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this.editorForm.patchValue({
      editor: value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    private localizationService: LocalizationService,
    private operators: Operators,
    protected fb: FormBuilder,
  ) {
    super(fb);

    this.userGroupFilters = [
      {
        field: 'includePassives',
        operator: this.operators.Equals,
        value: false,
      },
    ];

    this.userGroupSelectorOptions = {
      pageSize: 5,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      emptyText: this.localizationService.instant('::SelectUserGroup'),
      multiple: true,
      url: UserGroupDto.apiUrl,
      currentPage: 1,
      showSelections: false,
      showClearSelections: false,
      showClearSelectionLink: true,
      selectorPosition: 'Top',
      filters: this.userGroupFilters,
    };

    this.editorForm.valueChanges.subscribe(val => {
      this._value = val.editor;
      this.onChange();
    });
  }

  ngOnInit(): void {}

  reload(): void {}

  reset(): void {}

  autoSelectFirstItem(): void {}

  init() {
    super.init();
    if (this.actualConfig.autoLoad) {
      this.userGroupSelector.refresh();
    }
  }
}
